import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "count"]

  deposit(event) {
    this.mark(event.detail.filename, true)
  }

  discard(event) {
    this.mark(event.detail.filename, false)
  }

  mark(filename, deposited) {
    const row = this.rowTargets.find((candidate) => candidate.dataset.filename === this.normalize(filename))
    if (!row) return
    if (row.dataset.deposited === String(deposited)) return

    row.dataset.deposited = String(deposited)
    row.querySelector("[data-deposit-checklist-slot='deposited']").classList.toggle("hidden", !deposited)
    row.querySelector("[data-deposit-checklist-slot='missing']").classList.toggle("hidden", deposited)
    this.countTarget.textContent = this.rowTargets.filter((candidate) => candidate.dataset.deposited === "true").length
  }

  // Mirrors WorkflowEventImport#normalized_filename: Rails' upload sanitization,
  // then the case, the edge spaces and the macOS accent decomposition.
  normalize(filename) {
    return filename
      .trim()
      .replace(/[‮%$|:;/<>?*"\t\r\n\\]/g, "-")
      .toLowerCase()
      .normalize("NFC")
  }
}
